import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FolderPasswordService } from 'src/app/services/folder-password.service';

export interface FolderPasswordDialogData {
  folderName: string;
  passwordHash: string;
  folderId: string;
}

@Component({
  selector: 'app-folder-password-dialog',
  templateUrl: './folder-password-dialog.component.html',
  styleUrls: ['./folder-password-dialog.component.css'],
})
export class FolderPasswordDialogComponent {
  password: string = '';
  isWrong: boolean = false;
  isVerifying: boolean = false;
  showPassword: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<FolderPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FolderPasswordDialogData,
    private folderPasswordService: FolderPasswordService
  ) {}

  async verify(): Promise<void> {
    if (!this.password) return;
    this.isVerifying = true;
    this.isWrong = false;
    const ok = await this.folderPasswordService.verifyPassword(
      this.password,
      this.data.passwordHash
    );
    this.isVerifying = false;
    if (ok) {
      this.folderPasswordService.markJustUnlocked(this.data.folderId);
      this.dialogRef.close(true);
    } else {
      this.isWrong = true;
      this.password = '';
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
